module.exports = __webpack_public_path__ + "img/img3.c18c6e13.svg";